import { render, staticRenderFns } from "./Preventivo.vue?vue&type=template&id=6291c547&"
import script from "./Preventivo.vue?vue&type=script&lang=js&"
export * from "./Preventivo.vue?vue&type=script&lang=js&"
import style0 from "./Preventivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
